

export const ACTION_SUPPLIER_MANAGE_LIST_PORT = 'ACTION_SUPPLIER_MANAGE_LIST_PORT';



// WEBPACK FOOTER //
// ./src/store/Admin/modules/supplierManage/types.js